// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-menu-item{cursor:pointer}.active{font-weight:700!important;color:#006891!important}.invalid{-webkit-text-decoration:bold;text-decoration:bold;color:red}", ""]);
// Exports
module.exports = exports;
